import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { Calendars } from "../../../components/Calendar/Calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { NullString } from "../../../utilities/NullUtil";

import { DialogConfirm, DialogDelete, DialogViewPic } from "../../../components/DialogService/DialogService";
import { FooterButtonSigleCustom, FooterButtonCustomLabel, FooterButtonSigle } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { formatDateAPI, formatDateFile, formatDateConvert_2, dateTh } from "../../../utilities/DateUtil";
import { validateInputText, validateInputTextCus } from "../../../utilities/ValidateUtil";
import ValidateService from "../../../components/ValidateService/ValidateService";

//PAGE
import P207List from "./P207List";
import P207PicList from "./P207PicList";
import P207Dialog from "./P207Dialog";

//SERVICE
import { pSupervisorOrderInfo, pSupervisorOrderUpdate, getipAddress } from "../../../service/200/P207Service";
import { genPhotoList, genPhotoUpdate, genOrderTypeList, genContractRouteList, genContractNoList, genGetBranchInfo } from "../../../service/GEN/GenService";
import { commonUpload } from "../../../service/APP/AppService";
import { deCodeBase64 } from "../../../components/UploadPic/UploadPicUtil";

export default function P207() {
    const toast = useRef(null);
    const op = useRef(null);
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    // const [count, setCount] = useState(0);
    const [submitted, setSubmitted] = useState(false);

    // DATA
    const [errData, setErrData] = useState(null);
    const [dataTb, setDataTb] = useState([]);
    const [dataTbImage, setDataTbImage] = useState([]);
    const [dataForm, setDataForm] = useState({
        contractNo: "",
        displayMode: "",
        fixExpireCheckbox: "N",
        fixExpireDate: null,
        guidelineCheckbox: "N",
        guidelineNo: "",
        locationBegin: 0,
        locationEnd: 0,
        orderNo: "",
        orderSeq: 0,
        orderTopic: "",
        replyExpireCheckbox: "N",
        replyExpireDate: null,
        replyWithinDay: 0,
        routeNo: 0,
        seqPk: 0,
        urgentFixExpireCheckbox: "N",
        urgentFixExpireDate: null,
        originalRequestNo: "",
        recordStamp: 0,
        orderRemark: "",
    });

    const [ip, setIP] = useState("");

    // SEARCH
    const [searchData, setSearchData] = useState({
        requestNo: "",
        contractNo: "",
        orderNo: "",
        routeNo: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
        from: "",
        action: "",
        locationBegin: "",
        locationEnd: "",
    });

    // ActionStatus add row
    const [statusAddRow, setStatusAddRow] = useState(false);

    //Pic
    const [deletePicDialog, setDeletePicDialog] = useState(false);
    const [dialogUpload, setDialogUpload] = useState({ dialog: false, show: false });
    const [dataFile, setDataFile] = useState([]);

    // View Pic
    const [dialogPic, setDialogPic] = useState({ dialog: false, pic: "", show: false });

    // DIALOG
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => { },
        onCancle: () => { },
        footerBtn: () => { },
    });

    // DropList แสดงรายการใน dropdown ใบสั่งงานเฉพาะอย่าง
    const [orderTypeList, setOrderTypeList] = useState([]);
    // DropList เลขที่สัญญา
    const [contractNoItem, setContractNoItem] = useState([]);
    // DropList เลขที่เส้นทาง
    const [contractRouteItem, setContractRouteItem] = useState([]);

    // count btn save
    const [countBtnSave, setCountBtnSave] = useState(0);

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setSearchData({
                    ...searchData,
                    ...history.location.state,
                });
            } else {
                history.push("/200");
                // setSearchData({
                //     ...searchData,
                //     orderNo: "S65100190",
                // });
            }
        } else {
            history.push("/login");
        }
    }, []);
    useEffect(() => {
        if (searchData.requestNo !== "") {
            getSupervisorOrderInfo();
        }

        if (searchData.contractNo !== "") getContractRouteList(searchData.contractNo);

        getgenOrderTypeList();
        getConstactNo();
        getIp();

        getGenPhotoList();

        if (searchData.from === "206") {
            handlerSetDataFormSubmit("contractNo", searchData.contractNo);
            handlerSetDataFormSubmit("routeNo", searchData.routeNo);
        }
    }, [searchData]);

    useEffect(() => { }, [dataFile]);

    useEffect(() => {
        if (dataTb.length === 0 && statusAddRow === true) {
            setTimeout(() => {
                handlerAddRowTable([]);
            }, 1000);
        }
    }, [dataTb]);

    const getgenOrderTypeList = () => {
        const req = { userId: dataUserSession().userId };

        genOrderTypeList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    let arr = [];
                    res.data.forEach((item, index) => {
                        if (item.orderDesc !== null) arr.push({ name: item.orderDesc, code: item.orderTopic });
                    });
                    setOrderTypeList(arr);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const getIp = () => {
        getipAddress().then(
            (res) => {
                setLoading(false);
                setIP(res);
            },
            function (err) { }
        );
    };

    const getContractRouteList = (contractNo) => {
        const req = { userId: dataUserSession().userId, contractNo: contractNo };
        genContractRouteList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    let arr = [];
                    res.data.map((item, index) => {
                        if (item.routeName !== null) arr.push({ name: item.routeName, code: item.routeNo });
                    });
                    setContractRouteItem(arr);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const getConstactNo = () => {
        const req = { userId: dataUserSession().userId };
        genContractNoList(req).then(
            (res) => {
                setLoading(false);
                if (res.status === 200) {
                    let arr = [];
                    res.data.forEach((item, index) => {
                        if (item.contractNo !== null) arr.push({ name: item.contractNo, code: item.seqPk });
                    });
                    setContractNoItem(arr);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const getSupervisorOrderInfo = (_requestNo = "") => {
        setLoading(true);
        const req = {
            orderNo: _requestNo === "" ? searchData.requestNo === "" ? searchData.orderNo : searchData.requestNo : _requestNo,
            userId: searchData.userId,
        };

        pSupervisorOrderInfo(req).then(
            (res) => {
                setLoading(false);
                if (res.data.length > 0 && res.data.length[0] !== null) {
                    let temp = [];
                    let index = 0;

                    res.data.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    if (res.data[0].orderSeq !== 0) setDataTb(temp);

                    setDataForm(temp[0]);
                    getContractRouteList(temp[0].contractNo);
                    getGenPhotoList();
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };
    const getGenPhotoList = () => {
        const req = {
            userId: searchData.userId,
            requestNo: searchData.requestNo,
            photoType: "C001",
        };
        genPhotoList(req).then(
            (res) => {
                setLoading(false);

                if (res !== undefined) {
                    let temp = [];
                    let index = 0;
                    if (res.data.length) {
                        res.data.forEach((element) => {
                            temp.push({
                                ...element,
                                index: index,
                            });
                            index++;
                        });
                        setDataTbImage(temp);
                    } else {
                        setDataTbImage([]);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const validation = (object) => {
        if (object.contractNo === "" || object.routeNo === "" || object.locationEnd < object.locationBegin) {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };

    const submitForm = (act) => {
        if (validation(dataForm)) {
            if (dataTb.length > 0) {
                setLoading(true);

                // 31/01/2022
                const reqNo = searchData.requestNo; //searchData.page === "208" ? searchData.requestNo : "";

                for (let i = 0; i < dataTb.length; i++) {
                    // const orNo = searchData.action === "NEW" ? searchData.orderNo : dataTb[i].orderNo;

                    const checkEmptydate = (str) => {
                        if (str === "0001-01-01" || str === "") {
                            return "";
                        } else {
                            return formatDateAPI(str);
                        }
                    };

                    const req = {
                        actionCode: act,
                        userId: searchData.userId,
                        contractNo: dataForm.contractNo,
                        fixExpireCheckbox: dataForm.fixExpireCheckbox,
                        fixExpireDate: NullString(dataForm.fixExpireDate) === "" ? "" : checkEmptydate(formatDateConvert_2(dataForm.fixExpireDate)),
                        guidelineCheckbox: dataForm.guidelineCheckbox,
                        guidelineNo: dataForm.guidelineNo == null ? "" : dataForm.guidelineNo,
                        locationBegin: parseFloat(dataForm.locationBegin),
                        locationEnd: parseFloat(dataForm.locationEnd),
                        orderNo: searchData.from === "206" ? "" : setValViewForm("orderNo"),
                        orderSeq: dataTb[i].orderSeq,
                        orderTopic: dataTb[i].orderTopic,
                        otherDesc: dataTb[i].otherDesc == "" || dataTb[i].otherDesc == undefined ? "" : dataTb[i].otherDesc,
                        replyExpireCheckbox: dataForm.replyExpireCheckbox,
                        replyExpireDate: NullString(dataForm.replyExpireDate) === "" ? "" : checkEmptydate(formatDateConvert_2(dataForm.replyExpireDate)),
                        replyWithinDay: dataForm.replyWithinDay,
                        requestNo: reqNo,
                        routeNo: dataForm.routeNo,
                        urgentFixExpireCheckbox: dataForm.urgentFixExpireCheckbox,
                        urgentFixExpireDate: NullString(dataForm.urgentFixExpireDate) === "" ? "" : checkEmptydate(formatDateConvert_2(dataForm.urgentFixExpireDate)),
                        recordStamp: dataForm.recordStamp,
                        orderRemark: dataForm.orderRemark,
                    };

                    pSupervisorOrderUpdate(req).then(
                        (res) => {
                            setLoading(false);
                            if (res.status === 200) {
                                setSearchData({ ...searchData, action: "EDIT", orderNo: res.data[0].orderNo });
                                getSupervisorOrderInfo(res.data[0].orderNo);
                                if (act === "A") {
                                    setCountBtnSave(1);
                                    secondSubmit(reqNo, res.data[0].orderNo);
                                    handlerSettingDialogConfirm(res.data[0].statusCode === "C" ? "" : "", res.data[0].statusText, res.data[0].orderNo);
                                } else {
                                    if (act === "S") {
                                        handlerDialogSend("", res.data[0].statusCode === "C" ? "ส่งผู้รับเหมาเรียบร้อยแล้ว" : "บันทึกมีข้อผิดพลาด", "");
                                    } else if (act === "D") {
                                        handlerDialogCancel("", res.data[0].statusCode === "C" ? "ยกเลิกรายการนี้สำเร็จ" : "บันทึกมีข้อผิดพลาด", "");
                                    } else {
                                        handlerSettingDialogConfirm("", res.data[0].statusCode === "C" ? "บันทึกสมบูรณ์" : "บันทึกมีข้อผิดพลาด", "");
                                    }
                                }
                            } else {
                                showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                            }
                        },
                        function (err) {
                            setLoading(false);
                            setErrData(err);
                        }
                    );
                    if (act === "A") {
                        if (i === 0) {
                            break;
                        }
                    }
                }
            } else {
                showMessages("error", ` `, "กรุณาเพิ่มรายการ");
            }
        } else {
            showMessages("error", ` `, "กรุณากรอกข้อมูล");
        }
    };
    const secondSubmit = (reqNo, orderno) => {
        for (let i = 1; i < dataTb.length; i++) {


            const fixExpireDate = dataForm.fixExpireCheckbox === "Y" ? dataForm.fixExpireDate : "";
            const replyExpireDate = dataForm.urgentFixExpireCheckbox === "Y" ? dataForm.replyExpireDate : "";
            const urgentFixExpireDate = dataForm.fixExpireCheckbox === "Y" ? dataForm.urgentFixExpireDate : "";

            const req = {
                recordStamp: dataForm.recordStamp,
                actionCode: "A",
                userId: searchData.userId,
                contractNo: dataForm.contractNo,
                fixExpireCheckbox: dataForm.fixExpireCheckbox,
                fixExpireDate: fixExpireDate === "" ? "" : formatDateAPI(formatDateConvert_2(fixExpireDate)),
                guidelineCheckbox: dataForm.guidelineCheckbox,
                guidelineNo: dataForm.guidelineNo == null ? "" : dataForm.guidelineNo,
                locationBegin: parseFloat(dataForm.locationBegin),
                locationEnd: parseFloat(dataForm.locationEnd),
                orderNo: orderno,
                orderSeq: dataTb[i].orderSeq,
                orderTopic: dataTb[i].orderTopic,
                otherDesc: dataTb[i].otherDesc == "" || dataTb[i].otherDesc == undefined ? "" : dataTb[i].otherDesc,
                replyExpireCheckbox: dataForm.replyExpireCheckbox,
                replyExpireDate: replyExpireDate == "" ? "" : formatDateAPI(formatDateConvert_2(replyExpireDate)),
                replyWithinDay: dataForm.replyWithinDay,
                requestNo: reqNo,
                routeNo: dataForm.routeNo,
                urgentFixExpireCheckbox: dataForm.urgentFixExpireCheckbox,
                urgentFixExpireDate: urgentFixExpireDate === "" ? "" : formatDateAPI(formatDateConvert_2(urgentFixExpireDate)),
                orderRemark: dataForm.orderRemark,
            };
            pSupervisorOrderUpdate(req).then(
                (res) => {

                    setLoading(false);
                    if (res.status === 200) {
                        // getSupervisorOrderInfo();
                        handlerSettingDialogConfirm(res.data[0].statusCode === "C" ? "" : "", res.data[0].statusText, res.data[0].orderNo);
                    } else {
                        showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const footerButtonSingle2 = () => {
        const con = () => {
            setConfirmDialog(false);
            history.push("/200");
        };
        return <FooterButtonSigleCustom btnLabel="ตกลง" icon="pi pi-check" onClick={() => con()} />;
    };

    const footerButtonSingle4 = () => {
        const con = () => {
            setConfirmDialog(false);
            history.push("/200");
        };
        return <FooterButtonSigle btnLabel="ปิด" onClick={() => con()} />;
    };

    const footerButtonSingle3 = (orNo) => {
        const con = () => {
            setSearchData({ ...searchData, requestNo: orNo });

            setConfirmDialog(false);
        };
        return <FooterButtonSigle btnLabel="ปิด" onClick={() => con()} />;
    };

    const handlerDialogCancel = (header, content) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle4(),
            onCancle: () => footerButtonSingle2(),
        });
        setConfirmDialog({ open: true });
    };

    const handlerDialogSend = (header, content, orNo) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle4(orNo),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    const toggle = (event) => {
        op.current.toggle(event);
    };

    const setValViewForm = (_key) => {
        if (dataForm !== null) return dataForm[_key];
    };

    const handlerAddRowTable = (d) => {
        setStatusAddRow(true);

        const data = {
            orderTopic: "",
            otherDesc: "",
            userId: searchData.userId,
            orderNo: setValViewForm("orderNo"),
            index: d.length,
            orderSeq: dataTb.length + 1,
        };
        setDataTb((current) => [...current, data]);
    };

    const handlerTableUpdateDataForm = (e, rowData, inputName) => {
        const val = e || "";
        const newList = [...dataTb];
        const editIndex = newList.findIndex((item) => {
            return item.index === rowData.index;
        });
        if (editIndex > -1) {
            let newData = newList[editIndex];
            newData = {
                ...newData,
                [`${inputName}`]: val,
            };
            newList[editIndex] = newData;

            setDataTb(newList);
        }
    };

    const handlerSetDataFormSubmit = (key, value) => {
        setDataForm((current) => ({ ...current, [key]: value }));
    };

    const footerButton = () => {
        const handlerDeleteData = () => {
            const _filter = dataTb.filter((data) => data.orderSeq != deleteDialog.data.orderSeq);

            _filter.map((t, i) => {
                return (_filter[i].index = i);
            });
            _filter.map((t, i) => {
                return (_filter[i].orderSeq = i + 1);
            });

            setDataTb(_filter);

            setDeleteDialog(false);
        };

        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const handlerGenPhotoUpdate = (act, path) => {
        const updatePhoto = (req) => {
            genPhotoUpdate(req).then(
                (res) => {
                    if (res.status === 200) {
                        getGenPhotoList();

                        if (res.data.length > 0) {
                            const _res = res.data[0];
                            setdialogOption({
                                ...dialogOption,

                                content: _res.statusText === "" ? "" : _res.statusText,
                                footerBtn: () => footerButtonClose(),
                                onCancle: () => setConfirmDialog(false),
                            });
                            setConfirmDialog({ open: true });
                        }
                    } else {
                        showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                    }

                    setLoading(false);
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        };

        if (act === "D") {
            const req = {
                actionCode: act,
                originalId: deletePicDialog.data.originalId,
                photoDesc: deletePicDialog.data.photoDesc,
                photoPath: deletePicDialog.data.photoPath,
                photoSeq: deletePicDialog.data.photoSeq,
                photoType: "C001",
                requestNo: searchData.requestNo,
                thumbnailPath: deletePicDialog.data.thumbnailPath,
                userId: searchData.userId,
            };
            updatePhoto(req);
        } else if (act === "A") {
            const req = {
                actionCode: act,
                originalId: ip,
                photoDesc: "",
                photoPath: path,
                photoSeq: 0,
                photoType: "C001",
                requestNo: searchData.requestNo,
                thumbnailPath: "",
                userId: searchData.userId,
            };

            updatePhoto(req);
        }
    };

    const footerDeletePicButton = () => {
        const handlerDeletePicData = () => {
            handlerGenPhotoUpdate("D");

            setDeletePicDialog(false);
        };

        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => handlerDeletePicData()} onClickCancle={() => setDeletePicDialog(false)} />;
    };

    const handlerOnSavePic = () => {
        for (let i = 0; i < dataFile.length; i++) {
            const req = {
                orderNo: "",
                requestNo: dataForm.contractNo.replace("/", ""),
                userId: searchData.userId,
            };

            genGetBranchInfo(req).then(
                (res) => {
                    setLoading(false);
                    if (res !== undefined) {
                        onUploadPic(res[0], i);
                    } else {
                        showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }

        setDialogUpload({ dialog: false, show: false });
    };

    const onUploadPic = (obj, i) => {
        setLoading(true);

        const req = {
            base64Pic: deCodeBase64(dataFile[i].fileUpload),
            branchId: obj.branchCode,
            fiscalYear: obj.fiscalYear,
            orderNo: "",
            picName: formatDateFile(new Date(), true) + "_" + i + "_" + dataForm.contractNo.replace("/", ""),
            requestNo: dataForm.contractNo.replace("/", ""),
            userId: dataForm.userId,
            picType: dataFile[i].fileUpload.typefile,
        };
        commonUpload(req).then(
            (res) => {
                setLoading(false);
                handlerGenPhotoUpdate("A", res.picPath);

                const old = dataFile[i];
                const modifly = { ...old, picPath: res.picPath, picUrl: res.picUrl };
                setDataFile(modifly);

                if (res !== undefined) {
                } else {
                    showMessages("error", "เกิดข้อผิดพลาด1", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const display_mode = () => {
        // 31/01/2022
        // return setValViewForm("displayMode") === "Y" && searchData === "200" ? true : false;
        return setValViewForm("displayMode") === "Y" ? true : false;
    };

    const disSelect = () => {
        if (setValViewForm("orderNo") !== "" || searchData.from === "206" || setValViewForm("displayMode") === "Y") {
            return true;
        } else {
            return false;
        }
    };

    const handlerCheck = (key, chk) => {
        handlerSetDataFormSubmit(key, chk === true ? "Y" : "N");
    };

    const isSelectedBox = (key) => {
        let chk = dataForm[key];

        if (chk === "Y" && setValViewForm("displayMode") === "N") {
            return false;
        } else {
            if (chk == "N" || chk == "" || setValViewForm("displayMode") === "Y" || searchData === "200") {
                return true;
            }
        }
    };

    const handlerSetActionAdd = () => {
        // return searchData.action === "NEW" && setValViewForm("orderNo") === "" ? "A" : "U";
        return "A";
    };

    const disAddPicNewWork = () => {
        return setValViewForm("orderNo") === "" || setValViewForm("displayMode") === "Y" ? true : false;
    };

    const validateViewImage = () => {
        return setValViewForm("orderNo") === "" ? [] : dataTbImage;
    };

    const handlerSettingDialogConfirm = (header, content, orNo) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle3(orNo), //footerButtonSingle
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };
    const footerButtonCon = (act) => {
        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => submitForm(act)} onClickCancle={() => setConfirmDialog(false)} />;
    };

    const footerButtonClose = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    setConfirmDialog({ open: false });
                }}
            />
        );
    };

    const handlerSettingDialogConfirm2 = (key, _content) => {
        setdialogOption({
            ...dialogOption,
            header: "",
            content: _content,
            footerBtn: () => footerButtonCon(key),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    const viewImage = (photoPath) => {
        setDialogPic({
            dialog: true,
            show: true,
            pic: photoPath,
        });
    };

    const disBtnSave = () => {
        return setValViewForm("displayMode") === "Y" || countBtnSave !== 0 ? true : false;
    };
    const btnDis = () => {
        if (setValViewForm("orderNo") === "" || setValViewForm("displayMode") === "Y") {
            return true;
        } else {
            if (countBtnSave === 0 && setValViewForm("orderNo") !== "") {
                return true;
            } else {
                return false;
            }
        }
    };

    const handlerDate = (date) => {
        return formatDateConvert_2(date);
    };
    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">งานสั่งการเฉพาะอย่าง</h2>
                        <hr /> */}
                        <div className="p-fluid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <label style={{ color: "red" }}>*</label>
                                <Dropdown
                                    className={submitted && !dataForm.contractNo ? "p-invalid" : ""}
                                    id="contractNo"
                                    value={searchData.from === "206" ? searchData.contractNo : setValViewForm("contractNo")}
                                    options={contractNoItem}
                                    disabled={disSelect()}
                                    optionLabel="name"
                                    optionValue="name"
                                    placeholder="เลือก เลขที่สัญญา"
                                    onChange={(e) => {
                                        handlerSetDataFormSubmit("contractNo", e.value);
                                        getContractRouteList(e.value);
                                    }}
                                />
                                {submitted && !dataForm.contractNo && validateInputText("contractNo", "เลขที่สัญญา")}
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="routeNo">เส้นทาง</label>
                                <label style={{ color: "red" }}>*</label>
                                <Dropdown
                                    className={submitted && !dataForm.routeNo ? "p-invalid" : ""}
                                    id="routeNo"
                                    value={searchData.from === "206" ? searchData.routeNo : setValViewForm("routeNo")}
                                    placeholder="เลือก เส้นทาง"
                                    disabled={disSelect()}
                                    options={contractRouteItem}
                                    optionLabel="name"
                                    optionValue="code"
                                    onChange={(e) => handlerSetDataFormSubmit("routeNo", e.target.value)}
                                />
                                {submitted && !dataForm.routeNo && validateInputText("routeNo", "เลขที่สัญญา")}
                            </div>
                        </div>
                        <div className="p-fluid  p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="orderNo">เลขที่งานสั่งการเฉพาะอย่าง</label>
                                <label style={{ color: "red" }}>*</label>
                                <InputText id="orderNo" type="text" disabled={true} maxLength="100" value={setValViewForm("orderNo")} onChange={(e) => handlerSetDataFormSubmit("orderNo", e.target.value)} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="orderNo">เลขที่ใบแจ้งฯ ต้นเรื่อง</label>
                                <label style={{ color: "red" }}>*</label>
                                <InputText
                                    id="orderNo"
                                    type="text"
                                    disabled={true}
                                    maxLength="100"
                                    value={setValViewForm("originalRequestNo")}
                                    // value={searchData.originalRequestNo}
                                    onChange={(e) => handlerSetDataFormSubmit("originalRequestNo", e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="p-fluid  p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationBegin">บริเวณก่อสร้าง</label>
                                <label style={{ color: "red" }}>*</label>
                                {setValViewForm("displayMode") === "Y" ? (
                                    <InputText id="locationBegin" type="text" disabled={true} maxLength="20" value={setValViewForm("locationBeginDisplay")} />
                                ) : (
                                    <InputNumber
                                        className={setValViewForm("locationBegin") && !setValViewForm("locationBegin") ? "p-invalid" : ""}
                                        inputId="locationBegin"
                                        value={setValViewForm("locationBegin")}
                                        onValueChange={(e) => handlerSetDataFormSubmit("locationBegin", e.value)}
                                        mode="decimal"
                                        useGrouping={false}
                                        minFractionDigits={3}
                                        maxFractionDigits={3}
                                        placeholder="ระบุ บริเวณก่อสร้าง"
                                        disabled={display_mode()}
                                    />
                                )}
                            </div>
                            {setValViewForm("locationBegin") === null && !setValViewForm("locationBegin") && validateInputText("locationBegin", "บริเวณก่อสร้าง")}

                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationEnd">ถึง</label>
                                <label style={{ color: "red" }}>*</label>
                                {setValViewForm("displayMode") === "Y" ? (
                                    <InputText id="locationEnd" type="text" disabled={true} maxLength="20" value={setValViewForm("locationEndDisplay")} />
                                ) : (
                                    <InputNumber
                                        className={setValViewForm("locationEnd") < setValViewForm("locationEnd") ? "p-invalid" : ""}
                                        inputId="locationEnd"
                                        value={setValViewForm("locationEnd")}
                                        placeholder="ระบุ ถึง"
                                        onValueChange={(e) => handlerSetDataFormSubmit("locationEnd", e.value)}
                                        mode="decimal"
                                        useGrouping={false}
                                        minFractionDigits={3}
                                        maxFractionDigits={3}
                                        disabled={display_mode()}
                                    />
                                )}

                                {setValViewForm("locationEnd") < setValViewForm("locationBegin") ? validateInputTextCus("locationEnd", "ต้องมากกว่าหรือเท่ากับบริเวณก่อสร้าง") : ""}
                            </div>
                        </div>
                        <hr />

                        <P207List dataTable={dataTb} dropdownOrderTypeList={orderTypeList} addRowtable={handlerAddRowTable} onChangeDrop={handlerTableUpdateDataForm} setheadlerInpusText={handlerTableUpdateDataForm} deleteDialog={setDeleteDialog} dis={display_mode()} />

                        <div className="p-fluid  p-grid">
                            <div className="p-field p-col-12 p-md-5">
                                <div className="p-col-12">
                                    <div className="p-fluid  p-grid">
                                        <div className="p-field p-col-12 p-md-6">
                                            <div className="p-field-checkbox">
                                                <Checkbox inputId="guidelineCheckbox" checked={setValViewForm("guidelineCheckbox") === "Y" ? true : false} onChange={(e) => handlerCheck("guidelineCheckbox", e.checked)} disabled={display_mode()} />
                                                <label htmlFor="guidelineCheckbox">เพื่อเป็นแนวทางปฎิบัติข้อ</label>
                                            </div>
                                        </div>
                                        <div className="p-field p-col-12 p-md-6">
                                            <InputText id="guidelineNo" type="text" value={setValViewForm("guidelineNo")} onChange={(e) => handlerSetDataFormSubmit("guidelineNo", e.target.value)} disabled={isSelectedBox("guidelineCheckbox")} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12">
                                    <div className="p-fluid  p-grid ">
                                        <div className="p-field p-cow-12 p-md-6">
                                            <div className="p-field-checkbox">
                                                <Checkbox
                                                    inputId="fixExpireCheckbox"
                                                    checked={setValViewForm("fixExpireCheckbox") === "Y" ? true : false}
                                                    onChange={(e) => {
                                                        handlerCheck("fixExpireCheckbox", e.checked);
                                                    }}
                                                    disabled={display_mode()}
                                                />
                                                <label htmlFor="fixExpireCheckbox">เพื่อปรับปรุงแก้ไขภายในวันที่</label>
                                            </div>
                                        </div>
                                        <div className="p-field p-col-12 p-md-6">
                                            <Calendars
                                                key="fixExpireDate"
                                                id="fixExpireDate"
                                                value={setValViewForm("fixExpireDate") == "0001-01-01" || setValViewForm("fixExpireDate") == null ? "" : new Date(handlerDate(setValViewForm("fixExpireDate")))}
                                                onChange={(e) => {
                                                    handlerSetDataFormSubmit("fixExpireDate", dateTh(e.target.value));
                                                }}
                                                disabled={isSelectedBox("fixExpireCheckbox")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12">
                                    <div className="p-fluid  p-grid">
                                        <div className="p-field p-col-12 p-md-6">
                                            <div className="p-field-checkbox">
                                                <Checkbox inputId="urgentFixExpireCheckbox" checked={setValViewForm("urgentFixExpireCheckbox") === "Y" ? true : false} onChange={(e) => handlerCheck("urgentFixExpireCheckbox", e.checked)} disabled={display_mode()} />
                                                <label htmlFor="urgentFixExpireCheckbox">เพื่อเร่งรัดดำเนินการโดยด่วน ภายในวันที่</label>
                                            </div>
                                        </div>
                                        <div className="p-field p-col-12 p-md-6">
                                            <Calendars
                                                key="urgentFixExpireDate"
                                                id="urgentFixExpireDate"
                                                value={setValViewForm("urgentFixExpireDate") == "0001-01-01" || setValViewForm("urgentFixExpireDate") == null ? "" : new Date(handlerDate(setValViewForm("urgentFixExpireDate")))}
                                                onChange={(e) => handlerSetDataFormSubmit("urgentFixExpireDate", dateTh(e.target.value))}
                                                disabled={isSelectedBox("urgentFixExpireCheckbox")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12">
                                    <div className="p-fluid  p-grid">
                                        <div className="p-field p-col-12 p-md-6">
                                            <div className="p-field-checkbox">
                                                <Checkbox inputId="replyExpireCheckbox" checked={setValViewForm("replyExpireCheckbox") === "Y" ? true : false} onChange={(e) => handlerCheck("replyExpireCheckbox", e.checked)} disabled={display_mode()} />
                                                <label htmlFor="replyExpireCheckbox">โปรดตอบเป็นหนังสือภายในวันที่</label>
                                            </div>
                                        </div>
                                        <div className="p-field p-col-12 p-md-6">
                                            <Calendars
                                                key="replyExpireDate"
                                                id="replyExpireDate"
                                                value={setValViewForm("replyExpireDate") == "0001-01-01" || setValViewForm("replyExpireDate") == null ? "" : new Date(handlerDate(setValViewForm("replyExpireDate")))}
                                                onChange={(e) => handlerSetDataFormSubmit("replyExpireDate", dateTh(e.target.value))}
                                                disabled={isSelectedBox("replyExpireCheckbox")}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-1"></div>
                            <div className="p-field p-col-12 p-md-6">
                                <div className="p-grid">
                                    <div className="p-col-12">
                                        <div className="card">
                                            <P207PicList data={validateViewImage()} toggle={toggle} op={op} dialogDel={setDeletePicDialog} dialogUploadPic={setDialogUpload} disAddPicNewWork={disAddPicNewWork} viewImage={viewImage}></P207PicList>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="p-fluid  p-grid">
                            <div className="p-field p-col-12 p-md-3">
                                <label htmlFor="replyWithinDay">ให้ตอบกลับพร้อมแนบรูปถ่ายภายใน(วัน)</label>
                                <InputNumber inputId="replyWithinDay" value={setValViewForm("replyWithinDay")} onValueChange={(e) => handlerSetDataFormSubmit("replyWithinDay", e.value)} useGrouping={false} placeholder="ระบุ ให้ตอบกลับพร้อมแนบรูปถ่ายภายใน(วัน)" disabled={display_mode()} />
                            </div>
                        </div>
                        <div className="p-fluid  p-grid">
                            <div className="p-field p-col-12 p-md-3">
                                <label htmlFor="orderRemark">หมายเหตุ</label>
                                <InputTextarea id="orderRemark" rows={3} cols={30} value={setValViewForm("orderRemark")} onChange={(e) => handlerSetDataFormSubmit("orderRemark", e.target.value)}></InputTextarea>
                            </div>
                        </div>

                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <div className="p-grid" style={{ textAlign: "center" }}>
                                    <div className="p-col-2"></div>
                                    <div className="p-col-4">
                                        <Button
                                            className="p-button-success p-button"
                                            icon="pi pi-save"
                                            label="บันทึก"
                                            style={{ width: 170 }}
                                            onClick={() => {
                                                submitForm(handlerSetActionAdd());
                                                // if (searchData.action === "EDIT") {

                                                // }
                                            }}
                                            disabled={disBtnSave()}
                                        />
                                        <Button className="p-button-secondary p-button" icon="pi pi-arrow-left" label="กลับหน้าจอหลัก" style={{ width: 170, marginLeft: "5px" }} onClick={() => history.push("/200")} />
                                    </div>
                                    <div className="p-col-4">
                                        <Button className="p-button-warning p-button" icon="pi pi-sign-in" label="แจ้งผู้รับเหมาให้แก้ไข" style={{ marginLeft: "5px" }} onClick={() => handlerSettingDialogConfirm2("S", "ต้องการส่งข้อมูลให้ผู้รับเหมาหรือไม่")} disabled={btnDis()} />
                                        <Button className="p-button-danger p-button" icon="pi pi-times-circle" label="ยกเลิกรายการนี้" style={{ marginLeft: "5px" }} onClick={() => handlerSettingDialogConfirm2("D", "ต้องการยกเลิกรายการนี้หรือไม่")} disabled={btnDis()} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <P207Dialog dialog={dialogUpload} setDialog={setDialogUpload} dataFile={dataFile} setDataFile={setDataFile} typeFile="jpg" onSaveFile={handlerOnSavePic} />
                    <DialogDelete visible={deleteDialog.open} header="" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="คุณต้องการลบข้อมูล ใช่หรือไม่ ?" />
                    <DialogDelete visible={deletePicDialog.open} header="" modal footer={footerDeletePicButton()} onHide={() => setDeletePicDialog(false)} textContent="คุณต้องการลบข้อมูล ใช่หรือไม่ ?" />
                    <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
                    <DialogViewPic dialog={dialogPic} data={dialogPic.pic} modal setDialogPic={setDialogPic} />
                </div>
            </div>
        </>
    );
}
